define([
    "./menuModule",
    "./nlgMenu",
    "./menuController"], function () {
});